<template>
  <div class="sync">
    <el-dialog
      :close-on-click-modal="false"
      title="同步产品"
      width="600px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <div>
        <el-form ref="form" label-width="100px" :model="form">
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
            prop="shopId"
            label="店铺："
          >
            <el-select
              clearable
              filterable
              style="width: 100%"
              size="mini"
              v-model="form.shopId"
              @change="handleSelectShop"
              placeholder="请选择所属店铺"
            >
              <el-option
                v-if="item.authStatus == '02'"
                v-for="item in shopList"
                :key="item.value"
                :label="item.shopName"
                :value="item.shopId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
            size="small"
            prop="channel"
            label="选择物流："
          >
            <el-cascader
              :disabled="options.length == 0"
              v-model="form.channel"
              style="width:100%;"
              placeholder="请输入物流"
              :options="options"
              :props="{
                value: 'logistics_channel_id',
                label: 'logistics_channel_name',
              }"
              filterable
              clearable
            ></el-cascader>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sureImport" size="small">
          上传
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { syncOrder } from "@/api/order/all"
import { getShopList, syncShopee, getChannelList } from "@/api/shop/shop"

export default {
  name: "SyncShopee",
  data() {
    return {
      shopList: [],
      multipleSelection: [],
      percent: 0,
      loadingVisible: false,
      resultList: [],
      timer: null,
      successFlag: false,
      message: "数据可能延迟，请稍后刷新",
      showMessage: false,
      form: {
        shopId: "",
        remitId: "",
        channel: "",
      },
      options: [],
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    ids: {
      type: String,
      default() {
        return ""
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.showMessage = false
        this.successFlag = false
        this.percent = 0
      }
    },
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    getData() {
      getShopList({ platNo: "05" }).then((res) => {
        this.shopList = res.rows
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.$emit("onClose")
      this.$emit("update")
      this.loadingVisible = false
    },
    completeDate(value) {
      return value < 10 ? "0" + value : value
    },
    async handleSelectShop(shopId) {
      try {
        let result = await getChannelList({ shopId })
        this.options = result.data.response.logistics_channel_list
      } catch (error) {
        this.options = []
      }
    },
    sureImport() {
      this.$refs["form"].validate(async (valid) => {
        this.startLoading()
        if (valid) {
          let form = this.form
          let ids = this.ids.split(",")
          try {
            for (let record of ids) {
              await syncShopee({
                remitId: record,
                shopId: form.shopId,
                channel: form.channel[0],
              })
            }
            this.msgSuccess("发布成功")
            this.endLoading()
            this.$emit("update")
          } catch (error) {
            this.endLoading()
            // this.msgError(error)
          }
        } else {
          this.endLoading()
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}
.sync-table {
  overflow-y: auto;
  max-height: 260px;
}
.status {
  margin: 10px 0;
}
.red {
  color: red;
}
.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}
.detail .list {
  padding: 5px 20px;
  box-sizing: border-box;
  width: 100%;
}
</style>
